/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * 十八线_接口文档
 * 十八线——小众旅游
 * OpenAPI spec version: 版本号:0.0.1
 */
import type {
  AjaxResult,
  DictTypePathParameters,
  Export13Params,
  GetInfo27PathParameters,
  List27Params,
  Remove21PathParameters,
  SysDictData,
  TableDataInfo
} from '../../../types/api';

import { orvalMutator } from '../../../utils/orval-mutator';



  export const get = () => {
/**
 * @summary 修改保存字典类型
 */
const edit9 = (
    sysDictData: SysDictData,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/system/dict/data`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: sysDictData
    },
      );
    }
  /**
 * @summary 新增字典类型
 */
const add10 = (
    sysDictData: SysDictData,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/system/dict/data`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sysDictData
    },
      );
    }
  /**
 * @summary 导出字典数据
 */
const export13 = (
    params: Export13Params,
 ) => {
      return orvalMutator<void>(
      {url: `/system/dict/data/export`, method: 'POST',
        params
    },
      );
    }
  /**
 * @summary 查询字典数据详细
 */
const getInfo27 = (
    { dictCode }: GetInfo27PathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/system/dict/data/${dictCode}`, method: 'GET'
    },
      );
    }
  /**
 * @summary 根据字典类型查询字典数据信息
 */
const dictType = (
    { dictType }: DictTypePathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/system/dict/data/type/${dictType}`, method: 'GET'
    },
      );
    }
  /**
 * @summary 获取字典数据列表
 */
const list27 = (
    params: List27Params,
 ) => {
      return orvalMutator<TableDataInfo>(
      {url: `/system/dict/data/list`, method: 'GET',
        params
    },
      );
    }
  /**
 * @summary 删除字典类型
 */
const remove21 = (
    { dictCodes }: Remove21PathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/system/dict/data/${dictCodes}`, method: 'DELETE'
    },
      );
    }
  return {edit9,add10,export13,getInfo27,dictType,list27,remove21}};
export type Edit9Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['edit9']>>>
export type Add10Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['add10']>>>
export type Export13Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['export13']>>>
export type GetInfo27Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['getInfo27']>>>
export type DictTypeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['dictType']>>>
export type List27Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['list27']>>>
export type Remove21Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['remove21']>>>
